import Axios from 'axios'

/**
 * 自动管理分页信息，如：当前页数、每页条数、总条数等。只需要使用 changeCurrent() 和 changePageSize() 即可轻松管理分页的数据。
 * 注意：在 params 数组第一位注入分页所需的参数
 */
import { showConfirmDialog } from 'vant'
import { showToastU, tansParams} from '@/utils/common.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import cache from '@/utils/cache.js'

// 默认 json 格式
// Axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
console.log('===env===', import.meta.env)
// 创建axios实例
const service = Axios.create({
  // 跟环境相关的内容 改 变量， 不要改代码
  baseURL: import.meta.env.VITE_APP_BASE_API,
  // baseURL: '/zking/backend',
  // 超时 30s
  timeout: 30_000
})

// 请求拦截
service.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }
  console.log(config.url)
  store.commit('appStore/showLoading')
  // 定义请求头部分
  // config.headers.Authorization = getGlobleInfo().token
  // token
  // config.headers.token = getGlobleInfo().token
  // 用户id
  config.headers.userId = store.getters['userStore/getState']('userId')||''
  // config.headers.type = '518gift'
  gTimer.refresh()
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?' + tansParams(config.params)
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  if ((config.method === 'post' || config.method === 'put')) {
    const requestObj = {
      url: config.url,
      data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
      time: new Date().getTime()
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url // 请求地址
      const s_data = sessionObj.data // 请求数据
      const s_time = sessionObj.time // 请求时间
      const interval = 1000 // 间隔时间(ms)，小于此时间视为重复提交
      if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        // const message = '数据正在处理，请勿重复提交'
        // console.warn(`[${s_url}]: ` + message)
        // store.commit('appStore/hideLoading')
        // return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, (error) => {
  store.commit('appStore/hideLoading')
  return Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(res => {
  store.commit('appStore/hideLoading')
  // 二进制数据则直接返回
  // console.log('响应拦截器 成功', res, res.data.message)
  // showToast(res.data.message)
  if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
    console.debug('service.interceptors blob')
    return res
  }
  if (res.config.url === '/hwgk/report/api/report' || res.config.url === '/hwgk/report/api/export') {
    return res
  }
  // console.log('响应拦截器 成功', res, res.data.message)
  if(res.data.code===0){

    showToastU(res.data.message)
  }
  console.debug('service.interceptors', res)
  return Promise.resolve(res.data)
}, (error) => {
  store.commit('appStore/hideLoading')
  // console.log('响应拦截器 失败', error, error.data.message)
  showToastU(error.message)
  return Promise.resolve(error)
})

/**
 * 请求间隔计时器，超时重新登录
 */
const gTimer = {
  sessionTimerId: -1,
  // 3 hour
  sessionTime: 3 * 3600 * 1000,
  sessionCallback: function () {
    store.commit('userStore/logout')
    showConfirmDialog({
      title: '系统提示',
      message:
        '登录状态已过期，您可以继续留在该页面，或者重新登录',
      confirmButtonText: '重新登录'
    })
      .then(() => {
        // on confirm
        router.push({name: 'login'})
      })
      .catch(() => {
        // on cancel
      })
  },
  refresh: function () {
    if (this.sessionTimerId !== -1) {
      clearTimeout(this.sessionTimerId)
    }
    this.sessionTimerId = setTimeout(this.sessionCallback, this.sessionTime)
  }
}
/**
 * 发起请求
 * @param url 请求地址 e.g. /product/:id/duty/:id
 * @param params 请求参数 json format e.g. {id:'0001', name:'XX百万医疗险'}
 * @param isLoading 是否显示请求过渡动画 默认 false
 * @param method 默认 post
 */
const request = function (url, params = {}, config = {}, method = 'post') {
  if (url === null || url === undefined || url === '') {
    return Promise.resolve({
      code: 0,
      message: '请求地址为空'
    })
  }
  // 合并默认配置和自定义配置
  const requestConfig = {
    ...config,
    method,
    url
  }
  // 根据请求方法设置数据
  if (method === 'get') {
    requestConfig.params = params
  } else {
    requestConfig.data = params
  }
  return service(requestConfig)
}


export {
  request
}
export const getGlobleInfo = (type) => {
  const zkr_campaign_userInfo = store.getters['userStore/getInfoByKey']('zkr_campaign_userInfo') || {}
  const gInfo = {
    token: store.getters['userStore/getInfoByKey']('zkr_campaign_token'),
    userId: store.getters['userStore/getInfoByKey']('zkr_campaign_userId'),
    nickName: zkr_campaign_userInfo.nickName,
    headImgUrl: zkr_campaign_userInfo.headImgUrl
  }
  if (!gInfo.userId) {
    gInfo.userId = localStorage.getItem('zkr_campaign_userId') || localStorage.getItem('WXOpenId')
  }
  if (!gInfo.nickName) {
    gInfo.nickName = localStorage.getItem('zkr_campaign_nickName')
  }
  if (!gInfo.headImgUrl) {
    gInfo.headImgUrl = localStorage.getItem('zkr_campaign_headImgUrl')
  }
  try {
    const _uInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    if ((!gInfo.token || type === 'local') && _uInfo && _uInfo.cToken) {
      gInfo.token = _uInfo.cToken
    }
    if ((!gInfo.nickName || type === 'local') && _uInfo && _uInfo.cInfo && _uInfo.cInfo.name) {
      gInfo.nickName = _uInfo.cInfo.name
    }
  } catch (e) {
    console.error('getGlobleToken:error:', e)
  }
  return gInfo
}

// 定义导出接口请求
// const exportReportReq = (formData) => {
//   return axios({
//     url: '/report/api/report', // 对应后端的/api/report接口
//     method: 'post',
//     data: formData,
//     responseType: 'blob', // 接收二进制流
//     headers: {
//       'Content-Type': 'multipart/form-data',
//     }
//   })
// }


